import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["data", "isOptionDisabled", "isOptionUncheckable", "optionEcho", "valueName", "optionRender", "allowClear", "echo"],
    _excluded2 = ["path", "level"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { Fragment } from 'react';
import { CascaderSelectRender } from '../tools/select';
import { getTreeItemList } from '../tools/tree';
import CascaderDropdownLists from '../CascaderDropdownLists';
import Selector from '../Selector';
import Join from '../Join';
import { getObjectValue } from '../tools/util';
import { canTouch } from '../tools/touch';
import DropdownRadioOption from '../DropdownRadioOption';
export default CascaderSelectRender(function (_ref, _ref2, _ref3) {
  var change = _ref.change,
      selected = _ref.value,
      state = _ref.state,
      update = _ref.update,
      open = _ref.open,
      setOpen = _ref.setOpen;

  var data = _ref2.data,
      isOptionDisabled = _ref2.isOptionDisabled,
      isOptionUncheckable = _ref2.isOptionUncheckable,
      optionEcho = _ref2.optionEcho,
      valueName = _ref2.valueName,
      _optionRender = _ref2.optionRender,
      allowClear = _ref2.allowClear,
      _ref2$echo = _ref2.echo,
      echo = _ref2$echo === void 0 ? function (value) {
    return /*#__PURE__*/React.createElement(Join, {
      separator: " > "
    }, value.map(function (v, i) {
      return /*#__PURE__*/React.createElement(Fragment, {
        key: i
      }, getObjectValue(v, optionEcho));
    }));
  } : _ref2$echo,
      otherProps = _objectWithoutProperties(_ref2, _excluded);

  var getValue = _ref3.getValue,
      searchProps = _ref3.searchProps,
      dropdownListProps = _ref3.dropdownListProps,
      _ref3$options = _ref3.options,
      options = _ref3$options === void 0 ? [] : _ref3$options,
      maxDropdownWidth = _ref3.maxDropdownWidth;
  var selectedValue = selected !== null && selected !== void 0 ? selected : [];
  var selectedList = getTreeItemList(selectedValue, data, {
    valueName: valueName
  });
  return {
    selector: {
      Component: Selector,
      props: {
        allowClear: allowClear,
        onClick: function onClick() {
          setOpen(!open);
        },
        onClear: function onClear() {
          change(null);
          setOpen(false);
        },
        children: selected && echo(selectedList)
      }
    },
    maxDropdownWidth: maxDropdownWidth,
    dropdown: /*#__PURE__*/React.createElement(CascaderDropdownLists, _extends({}, otherProps, {
      state: state,
      data: options,
      update: update,
      dropdownListProps: dropdownListProps,
      valueName: valueName,
      optionRender: function optionRender(item, searchText, _ref4) {
        var path = _ref4.path,
            level = _ref4.level,
            other = _objectWithoutProperties(_ref4, _excluded2);

        var disabled = isOptionDisabled(item);
        var checked = selectedValue[level] === getValue(item);

        var children = _optionRender(item, searchText, _objectSpread({
          path: path,
          level: level
        }, other));

        var uncheckable = isOptionUncheckable(item);

        var toggle = function toggle(close) {
          if (!disabled && !uncheckable) {
            if (close) {
              setOpen(!open);
            }

            update({
              value: path.map(function (i) {
                return getValue(i);
              })
            });
            change();
          }
        };

        if (canTouch) {
          return {
            Component: DropdownRadioOption,
            checked: checked,
            disabled: disabled,
            onChange: function onChange() {
              toggle();
            },
            children: children,
            radioProps: {
              key: JSON.stringify(selected)
            }
          };
        }

        return {
          selected: checked,
          disabled: disabled,
          onClick: function onClick() {
            toggle(true);
          },
          children: children
        };
      },
      searchProps: searchProps
    }))
  };
});